import { createTheme } from "./base";

export default createTheme();
